import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCustomerList as _getCustomerList, getCinemaList as _getCinemaList, handChannelWarningRestrictions } from '@/api/goodsCenter';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      customRadio: 1,
      cinemaRadio: 1,
      activeName: 'custom',
      customForm: {
        id: '',
        name: '',
        page: 1,
        page_size: 20
      },
      cinemaForm: {
        cinema_name: '',
        standard_id: '',
        page: 1,
        pagesize: 20
      },
      // 列表查询参数
      setFormRule: {
        rule_name: '',
        adjust_type: ['1'],
        by_ratio_adjust: '',
        by_money_adjust: '',
        is_set_timing: '',
        is_show_line_price: '0',
        time_type: null,
        day_type: null,
        dayValue: []
      },
      times: [{
        value: ['00:00:00', '23:59:59']
      }],
      days: [{
        name: '周一',
        id: 1
      }, {
        name: '周二',
        id: 2
      }, {
        name: '周三',
        id: 3
      }, {
        name: '周四',
        id: 4
      }, {
        name: '周五',
        id: 5
      }, {
        name: '周六',
        id: 6
      }, {
        name: '周日',
        id: 0
      }],
      selected_standard_ids: [],
      tableKey: 0,
      pages: {},
      totalCount: null,
      customList: [],
      checkedCustom: [],
      checkedDelCustom: [],
      checkedCustomList: [],
      checkedCinemaList: [],
      cinemaList: [],
      checkedDelCinema: [],
      warning_restrictions: 0 // 折扣预警值
    };
  },
  computed: {
    priceType: function priceType() {
      if (this.setFormRule.adjust_type.length == 2) {
        return 'all';
      } else if (this.setFormRule.adjust_type.length) {
        if (this.setFormRule.adjust_type[0] == 1) {
          return 'ratio';
        } else {
          return 'money';
        }
      } else {
        return '';
      }
    }
  },
  created: function created() {
    var _ids;
    var ids = this.$route.query.ids;
    if (typeof ids === 'string') {
      ids = [ids];
    }
    this.selected_standard_ids = (_ids = ids) !== null && _ids !== void 0 && _ids.length ? ids : '';
  },
  methods: {
    // 获取折扣预警
    getChannelWarningRestrictions: function getChannelWarningRestrictions() {
      var _this = this;
      handChannelWarningRestrictions().then(function (res) {
        _this.warning_restrictions = Number(res.data.warning_restrictions);
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.getCustomerList();
      this.getCinemaList();
      this.$nextTick(function () {
        _this2.dialogVisible = true;
      });
    },
    // 获取所有影院列表
    getCinemaList: function getCinemaList() {
      var _this3 = this;
      _getCinemaList(_objectSpread(_objectSpread({}, this.cinemaForm), {}, {
        selected_standard_ids: this.selected_standard_ids
      })).then(function (res) {
        var _this3$selected_stand;
        _this3.cinemaList = res.data.data.data;
        // 处理电影资源调价进入  会带有选中的城市selected_standard_ids 需要赋值给已选影院列表
        // 没有selected_standard_ids则是影院规则列表进入完全靠自己勾选影院
        if ((_this3$selected_stand = _this3.selected_standard_ids) !== null && _this3$selected_stand !== void 0 && _this3$selected_stand.length) {
          _this3.checkedCinemaList = JSON.parse(JSON.stringify(res.data.data.data));
        }
        _this3.totalCount = res.data.data.totalCount;
      });
    },
    // 获取客户列表
    getCustomerList: function getCustomerList() {
      var _this4 = this;
      _getCustomerList(this.customForm).then(function (res) {
        _this4.customList = res.data.list;
        _this4.pages = res.pages;
      });
    },
    // 设置规则弹框 待选择客户table 选中事件
    handleSelectionCustom: function handleSelectionCustom(val, type) {
      if (type == 'custom') {
        this.checkedCustom = val;
      } else {
        this.checkedCinema = val;
      }
    },
    // 设置规则弹框 已选择客户table选中事件
    handleCheckedDelCustom: function handleCheckedDelCustom(val, type) {
      if (type == 'custom') {
        this.checkedDelCustom = val;
      } else {
        this.checkedDelCinema = val;
      }
    },
    // 搜索设置规则里的查询客户
    searchCustom: function searchCustom(type) {
      if (type == 'custom') {
        this.customForm.page = 1;
        this.getCustomerList();
      } else {
        this.cinemaForm.page = 1;
        this.getCinemaList();
      }
    },
    // 设置规则 批量添加客户
    batchAddCustom: function batchAddCustom(type) {
      if (type == 'custom') {
        var _this$checkedCustomLi;
        if (!this.checkedCustom.length) {
          this.$message.info('请选择需添加的客户');
          return false;
        }
        (_this$checkedCustomLi = this.checkedCustomList).push.apply(_this$checkedCustomLi, _toConsumableArray(this.checkedCustom));
        this.$refs.multipleTable.clearSelection();
      } else {
        var _this$checkedCinemaLi;
        this.tableKey++;
        if (!this.checkedCinema.length) {
          this.$message.info('请选择需添加的客户');
          return false;
        }
        (_this$checkedCinemaLi = this.checkedCinemaList).push.apply(_this$checkedCinemaLi, _toConsumableArray(this.checkedCinema));
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 批量删除客户
    batchDel: function batchDel(type) {
      var _this5 = this;
      if (type == 'custom') {
        this.checkedDelCustom.forEach(function (item) {
          var index = _this5.checkedCustomList.indexOf(item);
          if (index !== -1) {
            _this5.checkedCustomList.splice(index, 1);
          }
        });
      } else {
        this.checkedDelCinema.forEach(function (item) {
          var index = _this5.checkedCinemaList.indexOf(item);
          if (index !== -1) {
            _this5.checkedCinemaList.splice(index, 1);
          }
        });
      }
    },
    // 待选择客户的禁用选项框条件
    selectableCustom: function selectableCustom(row) {
      var flag = true;
      this.checkedCustomList.forEach(function (e) {
        if (e.id == row.id) {
          flag = false;
        }
      });
      return flag;
    },
    // 待选择影院的禁用选项框条件
    selectableCinema: function selectableCinema(row) {
      var flag = true;
      this.checkedCinemaList.forEach(function (e) {
        if (e.standard_id == row.standard_id) {
          flag = false;
        }
      });
      return flag;
    },
    submitAdjustRule: function submitAdjustRule() {
      var _this6 = this;
      this.$refs.setFormRule.validate(function (valid) {
        if (valid) {
          _this6.$confirm('为防止规则冲突，本公司用户不允许绑其他公司卡，不允许纯微信支付；系统自动完成相关开关的设置！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(function () {
            if (_this6.setFormRule.time_type == 2) {
              var timeIds = _this6.times.map(function (item) {
                return item.value;
              });
            }
            if (_this6.setFormRule.time_type == 2 && _this6.isOverlap(timeIds)) {
              _this6.$message.warning('请检查您选择的时间段是否有重叠');
              return false;
            }
            // 全选7天时落库为周一至周日，否则为指定周
            var day_type = _this6.setFormRule.dayValue.length === 7 ? 1 : 2;
            var params = _objectSpread(_objectSpread({}, _this6.setFormRule), {}, {
              day_type: day_type,
              times: timeIds,
              days: _this6.setFormRule.dayValue,
              selected_company_info: _this6.customRadio == 1 ? _this6.checkedCustomList.map(function (i) {
                return {
                  company_name: i.company_name,
                  id: i.id
                };
              }) : '-1',
              selected_standard_ids: _this6.cinemaRadio == 1 ? _this6.checkedCinemaList.map(function (i) {
                return i.standard_id;
              }) : '-1',
              type: 'add'
            });
            if (!_this6.checkedCustomList.length && _this6.customRadio == 1) {
              params.selected_company_info = '';
            }
            if (!_this6.checkedCinemaList.length && _this6.cinemaRadio == 1) {
              params.selected_standard_ids = '';
            }
            if (_this6.customRadio == -1 && _this6.cinemaRadio == -1) {
              _this6.$message.info('已存在全局规则，无法选择全部影院和全部客户');
              return false;
            }
            _this6.$emit('emitSubmit', params);
          }).catch(function () {});
        }
      });
    },
    // 校验时间是否有重叠
    isOverlap: function isOverlap(timeRanges) {
      // 将时间字符串转换为可以比较的数值
      var ranges = timeRanges.map(function (range) {
        return range.map(function (time) {
          var _time$split = time.split(':'),
            _time$split2 = _slicedToArray(_time$split, 3),
            hour = _time$split2[0],
            minute = _time$split2[1],
            second = _time$split2[2];
          return hour * 3600 + minute * 60 + second * 1;
        });
      });

      // 检查是否有任何范围与其他范围重叠
      for (var i = 0; i < ranges.length; i++) {
        for (var j = i + 1; j < ranges.length; j++) {
          if (ranges[i][0] < ranges[j][1] && ranges[j][0] < ranges[i][1]) {
            return true;
          }
        }
      }
      return false;
    },
    // 分页操作
    onChange: function onChange(val, type) {
      if (type == 'cinema') {
        this.cinemaForm.page = val;
        this.getCinemaList();
      } else if (type == 'custom') {
        this.customForm.page = val;
        this.getCustomerList();
      }
    },
    sizeChange: function sizeChange(val, type) {
      // this.form.pagesize = val
      if (type == 'cinema') {
        this.cinemaForm.pagesize = val;
        this.getCinemaList();
      } else if (type == 'custom') {
        this.customForm.page_size = val;
        this.getCustomerList();
      }
    },
    closeDialog: function closeDialog() {
      this.activeName = 'custom';
      this.customForm = {
        name: '',
        id: ''
      };
      this.setFormRule = {
        rule_name: '',
        adjust_type: ['1'],
        by_ratio_adjust: '',
        by_money_adjust: '',
        is_set_timing: '',
        time_type: null,
        day_type: null,
        dayValue: []
      };
      this.times = [{
        value: ['00:00:00', '23:59:59']
      }];
      this.$refs.setFormRule.resetFields();
      this.checkedCinemaList = [];
      this.checkedCustomList = [];
    },
    addTime: function addTime() {
      this.times.push({
        value: ['00:00:00', '23:59:59']
      });
    },
    delTime: function delTime(index) {
      this.times.splice(index, 1);
    }
  }
};